module.exports = __webpack_public_path__ + "img/Green-Sun.b744a990.png";